function futureTimesGroup(data) {
	var arr = []
	var weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
	var weeks_short = ['日', '一', '二', '三', '四', '五', '六'];
	for (var i = 0; i < data; i++) {
		var timp = new Date().getTime() + i * 24 * 60 * 60 * 1000;
		var year = new Date(timp).getFullYear()
		var month = new Date(timp).getMonth() + 1
		if (month < 10) {
			month = '0' + month
		}
		var date = new Date(timp).getDate()
		if (date < 10) {
			date = '0' + date
		}
		var week = weeks[new Date(timp).getDay()]
		var week_show = i == 0 ? '今' : i == 1 ? '明' : weeks_short[new Date(timp).getDay()]
		var week_short = weeks_short[new Date(timp).getDay()]
		var params = {
			timp: timp,
			year: year,
			month: month,
			date: date,
			week: week,
			week_show: week_show,
			week_short: week_short,
			nyr_heng: year + '-' + month + '-' + date,
			nyr_format: year + '/' + month + '/' + date,
			nyr_dian: year + '.' + month + '.' + date,
			nyr_zi: year + '年' + month + '月' + date + '日',
			month_date: month + '/' + date
		}
		arr.push(params)
	}
	return arr;
}

function datePrintStr (data){
    if (data) {
        var n_date = data.replace(/-/g, '/')

        n_date = n_date.replace(/\./g, '/')

        var ndate = new Date(n_date)
        // 年月日
        var ndateY = ndate.getFullYear()
        var ndateM = ndate.getMonth() + 1
        if (ndateM < 10) {
            ndateM = '0' + ndateM
        }
        var ndateD = ndate.getDate()
        if (ndateD < 10) {
            ndateD = '0' + ndateD
        }
        // 时分秒
        var ndateHours = ndate.getHours()
        if (ndateHours < 10) {
            ndateHours = '0' + ndateHours
        }
        var ndateMinutes = ndate.getMinutes()
        if (ndateMinutes < 10) {
            ndateMinutes = '0' + ndateMinutes
        }
        var ndateSeconds = ndate.getSeconds()
        if (ndateSeconds < 10) {
            ndateSeconds = '0' + ndateSeconds
        }
        var ndate_hms = ndateHours + ':' + ndateMinutes + ':' + ndateSeconds
        // 周
        var week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
        var week_short = ['日', '一', '二', '三', '四', '五', '六'];
        // 输出参数
        var param = {
            date_stemp: ndate.getTime(),
            date_nor: ndateY + '/' + ndateM + '/' + ndateD,
            date_hor: ndateY + '-' + ndateM + '-' + ndateD,
            date_pio: ndateY + '.' + ndateM + '.' + ndateD,
            date_pioP: ndateM + '.' + ndateD,
            date_ymd: ndateY + '年' + ndateM + '月' + ndateD + '日',
            date_ymdmd: ndateM + '月' + ndateD + '日',
            date_hms: ndate_hms,
            week: week[ndate.getDay()],
            stamp: ndate.getTime(),
            smonth_day: ndateM + '/' + ndateD,
            smonth_day_md: ndateM + '.' + ndateD,
            week_short: week_short[ndate.getDay()],
            date_ndateD: ndateD,
            date_ndate_ym: ndateY + '年' + ndateM + '月'
        }
        return param;
    } else {
        var ndate = new Date()
        // 年月日
        var ndateY = ndate.getFullYear()
        var ndateM = ndate.getMonth() + 1
        if (ndateM < 10) {
            ndateM = '0' + ndateM
        }
        var ndateD = ndate.getDate()
        if (ndateD < 10) {
            ndateD = '0' + ndateD
        }
        // 时分秒
        var ndateHours = ndate.getHours()
        if (ndateHours < 10) {
            ndateHours = '0' + ndateHours
        }
        var ndateMinutes = ndate.getMinutes()
        if (ndateMinutes < 10) {
            ndateMinutes = '0' + ndateMinutes
        }
        var ndateSeconds = ndate.getSeconds()
        if (ndateSeconds < 10) {
            ndateSeconds = '0' + ndateSeconds
        }
        var ndate_hms = ndateHours + ':' + ndateMinutes + ':' + ndateSeconds
        // 周
        var week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
        var week_short = ['日', '一', '二', '三', '四', '五', '六'];
        // 输出参数
        var param = {
            date_nor: ndateY + '/' + ndateM + '/' + ndateD,
            date_hours: ndateHours,
            date_hor: ndateY + '-' + ndateM + '-' + ndateD,
            date_pio: ndateY + '.' + ndateM + '.' + ndateD,
            date_ymd: ndateY + '年' + ndateM + '月' + ndateD + '日',
            date_hms: ndate_hms,
            week: week[ndate.getDay()],
            stamp: ndate.getTime(),
            smonth_day: ndateM + '/' + ndateD,
            week_short: week_short[ndate.getDay()],
            date_ndateD: ndateD
        }
        return param;
    }
}
function datePrintStr2 (data){
    if (data) {

        var ndate = new Date(data)
        // 年月日
        var ndateY = ndate.getFullYear()
        var ndateM = ndate.getMonth() + 1
        if (ndateM < 10) {
            ndateM = '0' + ndateM
        }
        var ndateD = ndate.getDate()
        if (ndateD < 10) {
            ndateD = '0' + ndateD
        }
        // 时分秒
        var ndateHours = ndate.getHours()
        if (ndateHours < 10) {
            ndateHours = '0' + ndateHours
        }
        var ndateMinutes = ndate.getMinutes()
        if (ndateMinutes < 10) {
            ndateMinutes = '0' + ndateMinutes
        }
        var ndateSeconds = ndate.getSeconds()
        if (ndateSeconds < 10) {
            ndateSeconds = '0' + ndateSeconds
        }
        var ndate_hms = ndateHours + ':' + ndateMinutes + ':' + ndateSeconds
        // 周
        var week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
        var week_short = ['日', '一', '二', '三', '四', '五', '六'];
        // 输出参数
        var param = {
            date_stemp: ndate.getTime(),
            date_nor: ndateY + '/' + ndateM + '/' + ndateD,
            date_hor: ndateY + '-' + ndateM + '-' + ndateD,
            date_pio: ndateY + '.' + ndateM + '.' + ndateD,
            date_pioP: ndateM + '.' + ndateD,
            date_ymd: ndateY + '年' + ndateM + '月' + ndateD + '日',
            date_ymdmd: ndateM + '月' + ndateD + '日',
            date_hms: ndate_hms,
            week: week[ndate.getDay()],
            stamp: ndate.getTime(),
            smonth_day: ndateM + '/' + ndateD,
            smonth_day_md: ndateM + '.' + ndateD,
            week_short: week_short[ndate.getDay()],
            date_ndateD: ndateD,
            date_ndate_ym: ndateY + '年' + ndateM + '月'
        }
        return param;
    }
}

function isPhone(phonenum) {
  var regex = /^(13[0-9]{9})|(14[0-9]{9})|(15[0-9]{9})|(16[0-9]{9})|(17[0-9]{9})|(18[0-9]{9})|(19[0-9]{9})$/;
  if (!regex.test(phonenum)) {
    return false;
  } else {
    return true
  }
}

// 字符串每4格添加一个空格
function expEasyNumber (value) {
  return value.replace(/\s/g, '').replace(/(\w{4})(?=\w)/g, '$1 ')
}

export {
	futureTimesGroup,
	datePrintStr,
	datePrintStr2,
	isPhone,
	expEasyNumber
}


// WEBPACK FOOTER //
// ./src/lib/utils.js